import * as React from "react";
import { connect } from "react-redux";
import { ThemeBreakpoints, ThemePalette, ThemeShadowSizes } from "@vwpfs/mary-air-lib/theme/_Types";
import { NavLink } from "react-router-dom";
import { formatDate } from "../../../../../utils/DateFormat";
import { Claims } from "../../../../../store/Claims/Types";
import { DispatchFunc } from "../../../../../store/ActionTypes";
import { RemoteScope } from "../../../../../store/RemoteTypes";
import { remoteTrigger } from "../../../../../store/RemoteActions";
import { Pagination } from "@vwpfs/mary-air-lib/components/air/06-molecules/Pagination";
import { Currency } from "@vwpfs/mary-air-lib/components/air/05-atoms/CurrencyDisplay";
import { Alignment, ButtonsWrapper, Orientation } from "@vwpfs/mary-air-lib/components/air/06-molecules/ButtonsWrapper";
import { RowData, Table } from "@vwpfs/mary-air-lib/components/air/06-molecules/Table";
import { Container } from "@vwpfs/mary-air-lib/components/air/03-base/Container";
import { Icon, IconNames } from "@vwpfs/mary-air-lib/components/air/05-atoms/Icon";
import { Button } from "@vwpfs/mary-air-lib/components/air/05-atoms/Button";
/**
 *
 */
interface OwnProps {
    results: Claims;
}
/**
 *
 */
interface DispatchProps {
    loadResults: (skip: number) => void;
}
/**
 *
 */
type Props = OwnProps & DispatchProps;
/**
 *
 */
export const mapDispatchToProps = (dispatch: DispatchFunc): DispatchProps => ({
    loadResults: (skip: number) => dispatch(remoteTrigger(RemoteScope.CLAIM_RESULTS, {
        skip: skip,
    })),
});
/**
 *
 */
export class ResultsComp
    extends React.Component<Props, {}> {
    /**
     *
     * @param props
     * @param ctx
     */
    public constructor(props: Props) {
        super(props);
        this.handlePageClick = this.handlePageClick.bind(this);
        this.getProcessedRows = this.getProcessedRows.bind(this);
        this.resultsData = this.resultsData.bind(this);
    }
    /**
     *
     */
    public render() {
        return (
            <React.Fragment>
                <Table
                    hasActions
                    data={{
                        columns: this.resultsData().columns,
                        rows: this.resultsData().rows,
                        sort: this.resultsData().sort,
                    }}
                />
                {(this.props.results.totalPages && this.props.results.totalPages > 1) ?
                    <Container
                        className="scl-h-text-align--center"
                        theme={{
                            padding: { "": { t: 3, b: 2 }, "sm": { t: 4, b: 3 } },
                        }}
                    >
                        <Pagination
                            pageCount={this.props.results.totalPages}
                            currentPage={this.props.results.number}
                            onPageChange={this.handlePageClick}
                            theme={{ palette: ThemePalette.CONTRAST_PRIMARY }}
                        />
                    </Container> : null}
            </React.Fragment>
        );
    }
    private handlePageClick(skip: number) {
        this.props.loadResults(skip);
    }
    /**
     *
     */
    private getProcessedRows(): RowData[] {
        return this.props.results.content.map((row, index) => ({
            id: row.id,
            data: [
                row.claimNumber,
                row.claimNumberPAH,
                <span key={`date${index}`}>{formatDate(new Date(row.claimDate), "DD-MM-YYYY")}</span>,
                row.policyId ? (
                    <a href={`/policies/${row.policyId}`} target="_blank" rel="noopener noreferrer">
                        <span className="scl-a-link scl-b-h scl-b-h6">
                            <Icon name="eye"/>&nbsp;&nbsp;{row.policyNumber}
                        </span>
                    </a>
                ) : row.policyNumber,
                (
                    <h6 key={`h6-${index}`}>
                        <Currency value={row.amount} />
                    </h6>
                ),
                (
                    <ButtonsWrapper
                        key={`navlink-${index}`}
                        asGroup
                        alignment={Alignment.RIGHT}
                        defaultOrientation={Orientation.HORIZONTAL}
                        orientations={{
                            [ThemeBreakpoints.XS]: Orientation.VERTICAL,
                            [ThemeBreakpoints.MD]: Orientation.HORIZONTAL,
                        }}
                    >
                            <NavLink to={`/claims/${row.id}`} >
                                <Button
                                    icon={IconNames.ARROW_RIGHT}
                                    theme={{
                                        palette: ThemePalette.CONTRAST_PRIMARY,
                                        shadow: ThemeShadowSizes.TINY,
                                    }}
                                />
                            </NavLink>
                    </ButtonsWrapper>
                ),
            ],
        }));
    }
    /**
     *
     */
    private resultsData() {
        return {
            sort: {
                column: 1,
                asc: true,
            },
            columns: [
                {
                    label: "Claim number",
                    sortable: true,
                },
                {
                    label: "Claim number (PAH)",
                },
                {
                    label: "Claim date",
                },
                {
                    label: "Policy number",
                },
                {
                    label: "Amount",
                    alignRight: true,
                },
                {
                    label: "Actions",
                },
            ],
            rows: this.getProcessedRows(),
        };
    }
}
/**
 *
 */
export const Results = connect(
    undefined,
    mapDispatchToProps,
)(ResultsComp);
